export const ISSUE_TYPE_COLOR = ['#e30000', '#990000', '	#934981', '#814fbc', '#666665', '#2779ca', '#007e9a', '#7ea800', '#ff9200', '#ff3265']

export const CODE_403 = 403